function toggleSameAddressButton() {
    var sameBillingAddress = $('#sameBillingAddress');
    var changeBillingAddress = $('#changeBillingAddress');
    $('.js-billingAddress__un-registered-user').prop("checked", true).trigger('click').trigger('change');
    if (sameBillingAddress.is(':checked')) {
        sameBillingAddress.parents('.billingAddressInfo').addClass('active')
    }
    $('.js-billingAddress__un-registered-user').on('click', function () {
        if (sameBillingAddress.is(':checked')) {
            $(this).parents('.billingAddressInfo').addClass('active');
            $('.addressFormBilling').removeClass('active');
        }
    })

    $('.js-shipping-method__item').each(function () {
        if ($(this).find('input').is(':checked')) {
            $(this).parents('.shippingMethods').addClass('active');
            localStorage.setItem('selectedShippingMethodValue',$(this).parents('.js-shippingMethod').data('json-config').shippingMethodID);
        }
    })

    $('.js-region-selector__item').each(function () {
        if ($(this).find('input').is(':checked')) {
            $(this).parents('.c-region-selector__item-wrapper').addClass('active');
        }
    })

    $('.js-shippingRegion').on('click', function () {
        $('.js-shippingRegion').removeClass('active');
        $(this).addClass('active');
    })

    $('.js-add-new-address-button').on('click', function () {
        if (changeBillingAddress.is(':checked')) {
            $(this).parents('.addressFormBilling').addClass('active');
            $('.billingAddressInfo').removeClass('active');
        }
    })
}
function setShippingMethodOnLoadFromStorage() {
    //sets shipping method on load
    var selectedShippingMethodValue = localStorage.getItem('selectedShippingMethodValue');
    if(selectedShippingMethodValue){
        setTimeout(function(){
            $('.js-shippingMethod').each(function () { 
                var $jsonConfig = $(this).data('json-config');
                if ($jsonConfig.shippingMethodID == selectedShippingMethodValue) { 
                     $('.js-shipping-method__option').first().click();
                     $(this).find('.js-shipping-method__body').click();
                }
            })
        },500);
    }
}
module.exports = {
    init: function () {
        toggleSameAddressButton(),
        setShippingMethodOnLoadFromStorage()
    }
}